'use strict';


function checkRequestBackForm(token) {
    //debugger;
    const reCaptchaVersion = document.getElementById('reCaptchaVersion').value;
    var gRecaptchaResponse;
    if (reCaptchaVersion == "ReCaptchaV2") {
        gRecaptchaResponse = $('#g-recaptcha-response').val();
    }
    else if (reCaptchaVersion == "ReCaptchaV3") {
        gRecaptchaResponse = token;
    }

    const charLengthErrorMessage = document.getElementById('charLimitErrorMessage').value;
    const invalidCharErrorMessage = document.getElementById('charInvalidErrorMessage').value;

    const fname = document.getElementById('fname').value;
    const lname = document.getElementById('lname').value;
    const mobile = document.getElementById('mobile').value;
    const phone = document.getElementById('phone').value;
    const state = document.getElementById('dropstate').value;
    const postcode = document.getElementById('postcode').value;
    const terms = document.getElementById('terms').checked;
    let valid = true;

    document.getElementById('errorFirst').style.display = "none";
    document.getElementById('errorLast').style.display = "none";
    document.getElementById('errorMobile').style.display = "none";
    document.getElementById('errorState').style.display = "none";
    document.getElementById('errorPostcode').style.display = "none";
    document.getElementById('errorPrivacy').style.display = "none";
    document.getElementById('errorPhone').style.display = "none";

    document.getElementById('fname').classList.remove("field-error");
    document.getElementById('lname').classList.remove("field-error");
    document.getElementById('mobile').classList.remove("field-error");
    document.getElementById('phone').classList.remove("field-error");
    document.getElementById('dropstate').classList.remove("field-error");
    document.getElementById('postcode').classList.remove("field-error");
    document.getElementById('terms').classList.remove("field-error");

    if (fname === "") {
        document.getElementById('fname').classList.add("field-error");
        document.getElementById('errorFirst').style.display = "block";
        document.getElementById('errorFirst').innerHTML = "First Name is required";
        valid = false;
    }
    else if (fname.length > 50) {
        document.getElementById('fname').classList.add("field-error");
        document.getElementById('errorFirst').style.display = "block";
        document.getElementById('errorFirst').innerHTML = charLengthErrorMessage;
        valid = false;
    }
    else if (!IsInputSecure(fname)) {
        document.getElementById('fname').classList.add("field-error");
        document.getElementById('errorFirst').style.display = "block";
        document.getElementById('errorFirst').innerHTML = invalidCharErrorMessage;
        valid = false;
    }

    if (lname === "") {
        document.getElementById('lname').classList.add("field-error");
        document.getElementById('errorLast').style.display = "block";
        document.getElementById('errorLast').innerHTML = "Last Name is required";
        valid = false;
    }
    else if (lname.length > 50) {
        document.getElementById('lname').classList.add("field-error");
        document.getElementById('errorLast').style.display = "block";
        document.getElementById('errorLast').innerHTML = charLengthErrorMessage;
        valid = false;
    }
    else if (!IsInputSecure(lname)) {
        document.getElementById('lname').classList.add("field-error");
        document.getElementById('errorLast').style.display = "block";
        document.getElementById('errorLast').innerHTML = invalidCharErrorMessage;
        valid = false;
    }

    if ((mobile === "") && (phone === "")) {
        document.getElementById('mobile').classList.add("field-error");
        document.getElementById('phone').classList.add("field-error");
        document.getElementById('errorMobile').style.display = "block";
        document.getElementById('errorMobile').innerHTML = "Either Mobile or Phone (Other) is required";
        valid = false;
    }
    if ((mobile !== "") || (phone !== "")) {
        if (mobile !== "") {
            if (mobile.length > 15) {
                document.getElementById('mobile').classList.add("field-error");
                document.getElementById('errorMobile').style.display = "block";
                document.getElementById('errorMobile').innerHTML = "Your entry exceeds the maximum character limit. Please try again";
                valid = false;
            }
            else if (!IsMobileValid(mobile)) {
                document.getElementById('mobile').classList.add("field-error");
                document.getElementById('errorMobile').style.display = "block";
                document.getElementById('errorMobile').innerHTML = "Mobile number is required";
                valid = false;
            }
        }

        if (phone !== "") {
            if (phone.length > 15) {
                document.getElementById('phone').classList.add("field-error");
                document.getElementById('errorPhone').style.display = "block";
                document.getElementById('errorPhone').innerHTML = "Your entry exceeds the maximum character limit. Please try again";
                valid = false;
            }
            else if (!ValidatePhoneRegex(phone)) {
                document.getElementById('phone').classList.add("field-error");
                document.getElementById('errorPhone').style.display = "block";
                document.getElementById('errorPhone').innerHTML = "Contact number is required";
                valid = false;
            }
        }
    }

    if (state === "Select State") {
        document.getElementById('dropstate').classList.add("field-error");
        document.getElementById('errorState').style.display = "block";
        document.getElementById('errorState').innerHTML = "State is required";
        valid = false;
    }
    else if (!IsInputSecure(state)) {
        document.getElementById('dropstate').classList.add("field-error");
        document.getElementById('errorState').style.display = "block";
        document.getElementById('errorState').innerHTML = invalidCharErrorMessage;
        valid = false;
    }

    if (postcode === "") {
        document.getElementById('postcode').classList.add("field-error");
        document.getElementById('errorPostcode').style.display = "block";
        document.getElementById('errorPostcode').innerHTML = "Postcode is required";
        valid = false;
    }
    if (postcode.length !== 4) {
        document.getElementById('postcode').classList.add("field-error");
        document.getElementById('errorPostcode').style.display = "block";
        document.getElementById('errorPostcode').innerHTML = "Postcode is required";
        valid = false;
    }

    if (terms == false) {
        document.getElementById('errorPrivacy').style.display = "block";
        valid = false;
    }

    if (reCaptchaVersion == "ReCaptchaV2") {
        const recaptcha = grecaptcha.getResponse();
        if (recaptcha === "") {
            document.getElementById('errorCaptcha').style.display = "block";
            valid = false;
        }
    }
 
    if (valid == true) {
        document.getElementById('errorCaptcha').style.display = "none";
        document.getElementById('SubmissionErrorMessage').value = "";
        document.getElementById('SubmissionErrorMessage').style.display = "none";

        if (reCaptchaVersion == "ReCaptchaV2") {
            SubmitForm_RequestCallback(fname, lname, mobile, phone, state, postcode, gRecaptchaResponse);
        }
        else if (reCaptchaVersion == "ReCaptchaV3") {
            var siteKey = document.getElementById('reCaptchaV3SiteKey').value;
            grecaptcha.ready(function () {
                grecaptcha.execute(siteKey, { action: 'request_callback' }).then(function (gRecaptchaResponse) {
                    SubmitForm_RequestCallback(fname, lname, mobile, phone, state, postcode, gRecaptchaResponse);
                });
            });
        }
    }
}

function SubmitForm_RequestCallback(fname, lname, mobile, phone, state, postcode, gRecaptchaResponse) {
    let formData = new FormData();
    formData.append('FirstName', fname);
    formData.append('LastName', lname);
    formData.append('Mobile', mobile);
    formData.append('Phone', phone);
    formData.append('State', state);
    formData.append('PostCode', postcode);
    formData.append('GRecaptchaResponse', gRecaptchaResponse);

    const url = "/SaveRequestACallBack";

    fetch(url,
    {
        body: formData,
        method: "post",
        headers: {
            "RequestVerificationToken": $("#requestCallBackFormInner [name='__RequestVerificationToken']").val()
        }
    })
    .then(response => {
        if (!response.ok) {
            document.getElementById('SubmissionErrorMessage').innerHTML = $("#formSubmissionErrorMessage").val();
            document.getElementById('SubmissionErrorMessage').style.display = "block";
        }
        return response.text()
    })
    .then(data => {
        //make sure response does not contain any unhandled error
        if (!data.includes("<html>")) {
            if (data == 'Submit') {
                document.getElementById('requestCallBackForm').style.display = "none";
                document.getElementById('successRequestForm').style.display = "block";

                document.getElementById('fname').value = "";
                document.getElementById('lname').value = "";
                document.getElementById('mobile').value = "";
                document.getElementById('phone').value = "";
                document.getElementById('dropstate').value = "";
                document.getElementById('postcode').value = "";
                document.getElementById('terms').checked = false;
                document.getElementById('errorCaptcha').style.display = "none";
                document.getElementById('SubmissionErrorMessage').value = "";
                document.getElementById('SubmissionErrorMessage').style.display = "none";
                grecaptcha.reset();
            }
            else if (data.startsWith("1")) { //error returned by failed form submission validation
                document.getElementById('SubmissionErrorMessage').style.display = "block";
                document.getElementById('SubmissionErrorMessage').innerHTML = data.slice(1); //remove the first character "1" used to indicate error type returned from back-end
            }
            else { //error returned by failed validation of reCAPTCHA, display error message
                document.getElementById('errorCaptcha').style.display = "block";
                document.getElementById('errorCaptcha').innerHTML = data;
            }
        }
    });
}


function onlyNumberKey(evt) {
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
        return false;
    return true;
}
